import React, { useEffect, useState } from "react";
import moment from "moment";

import api from '../utils/api';
import DragDrop from "./DragDrop";
import Loader from "../lib/components/Loader";
import constants from "../lib/constants";


const DraftOrder = () => {
    const [year, updateYear] = useState(moment().year());
    const [draftOrder, updateDraftOrder] = useState([]);
    const [isDraftProjected, updateIsDraftProjected] = useState(false);
    const [loading, updateLoading] = useState(false);
    const [error, updateError] = useState(false);

    useEffect(() => {
        updateLoading(true);
        updateError(false);
        api.get(`/api/v1/draft/${year}/order`).then(({ data: { order, isProjected } }) => {
            updateDraftOrder(order);
            updateIsDraftProjected(isProjected);
        }).catch(res => {
            console.error(res);
            updateError(true);
        }).finally(() => {
            updateLoading(false);
        });
    }, [year]);

    if (error) {
        return <div>Error loading draft order!</div>
    }

    const sendDraftOrder = () => {
        updateLoading(true);
        api.post(`/api/v1/draft/${year}/order`, { order: draftOrder, isProjected: isDraftProjected }).then(() => {
            alert('Draft order updated!');
        }).catch(res => {
            alert('Failed to update draft order');
            console.error(res);
        }).finally(() => {
            updateLoading(false);
        });
    }

    return (
        <div>
            {loading ? <Loader/> : (
                <div>
                    <div>
                        <select className="form-select" value={year} onChange={(e) => updateYear(e.target.value)}>
                            {constants.allDraftYears.map((year, index) => (
                                <option key={index} value={year}>{year}</option>
                            ))}
                        </select>
                    </div>
                    <button className="btn btn-primary" onClick={() => sendDraftOrder()}>Save Draft Data</button>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={isDraftProjected} onChange={(e) => updateIsDraftProjected(e.target.checked)}/>
                        <label className="form-check-label">Projected Draft</label>
                    </div>
                    <DragDrop items={draftOrder} onUpdate={(newDraftOrder) => updateDraftOrder(newDraftOrder)}/>
                </div>
            )}
        </div>
    )
}

export default DraftOrder;